export default {
  title: 'Intégration Wolt Drive',
  subtitle: "Visible uniquement par les responsables d'intégration.",
  steps: {
    request: {
      title: '1. Demander le lieu à Wolt',
      description:
        'Copie la ligne de ce restaurant pour la feuille Wolt partagée. Collez-la dans la colonne A de la prochaine ligne vide, puis prévenez Wolt sur le canal Slack commun.',
    },
    activate: {
      title: '2. Vérifier et activer',
      description:
        "Saisissez l'ID de lieu ajouté par Wolt dans la feuille. Il est vérifié avec un devis test de Wolt avant toute sauvegarde.",
    },
  },
  fields: {
    venue_id: {
      label: 'ID de lieu Wolt',
      placeholder: 'ex. 6736f9f5f9e2ab82f9150420',
      invalid: 'Un ID de lieu Wolt comporte 24 caractères et utilise uniquement 0–9 et a–f.',
    },
    priority: {
      label: 'Priorité du prestataire',
      options: {
        wolt_primary: 'Wolt en priorité, garder les prestataires actuels en secours',
        wolt_only: 'Wolt uniquement',
      },
    },
  },
  verification: {
    verified: 'Wolt a confirmé ce lieu.',
    failed: "Wolt n'a pas pu confirmer ce lieu.",
    wolt_reason: 'Wolt a indiqué : {{reason}}',
    unavailable_now:
      "Wolt ne peut pas livrer depuis ce site pour le moment ({{reason}}). Vous pouvez quand même l'enregistrer.",
  },
  preview: {
    label: 'Ordre des prestataires',
    none: 'aucun',
  },
  hints: {
    internal_delivery:
      'Ce restaurant livre avec ses propres livreurs. Wolt sera utilisé une fois le mode Livraison ci-dessous réglé sur livreurs externes.',
    invalid_stored_id:
      "L'ID de site enregistré {{venueId}} n'est pas un ID de site Wolt valide, donc Wolt n'est pas utilisé pour ce restaurant. Vérifiez et enregistrez le bon ID.",
  },
  buttons: {
    copy_details: 'Copier les détails',
    verify: 'Vérifier',
    save: 'Enregistrer',
  },
  confirm: {
    title: 'Activer Wolt Drive ?',
    description: "Enregistre l'ID de lieu {{venueId}} et change l'ordre des prestataires en : {{providers}}.",
    unsaved_providers: 'Les modifications non enregistrées de la liste de fournisseurs ci-dessous seront remplacées.',
    ok: 'Enregistrer',
    cancel: 'Annuler',
  },
  toasts: {
    copied: 'Copié',
    copy_failed: 'Impossible de copier les détails. Veuillez réessayer.',
    saved: 'Wolt Drive est configuré pour ce restaurant.',
    save_failed: "Impossible d'enregistrer. Veuillez réessayer.",
  },
};
